import { FunctionComponent, HTMLAttributes } from 'react';

const ViewDesktop: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.769231 0.5H15.2308C15.3795 0.5 15.5 0.620539 15.5 0.769231V15.2308C15.5 15.3795 15.3795 15.5 15.2308 15.5H0.769231C0.620539 15.5 0.5 15.3795 0.5 15.2308V0.769231C0.5 0.620539 0.620539 0.5 0.769231 0.5Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M1 8.5L1 7.5L15 7.5L15 8.5L1 8.5Z" fill="currentColor" />
  </svg>
);

export default ViewDesktop;
